import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Пропсы поля ввода
 */
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

/**
 * Компонент поля ввода
 */
const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ type, label, error, id, className, ...props }, ref) => {
    // Авто-генерация id для связки label ↔ input
    const generatedId = React.useId();
    const inputId = id || generatedId;
    return (
      <div className="space-y-1">
        {label && (
          <label htmlFor={inputId} className="text-sm font-medium text-muted-foreground">{label}</label>
        )}
        <input
          id={inputId}
          type={type}
          className={cn(
            // Стили .wf-input прототипа: padding 10px 12px, font 13px
            'flex w-full rounded-md border border-border bg-input px-3 py-2.5 text-[13px] text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:border-transparent disabled:cursor-not-allowed disabled:opacity-50',
            className,
            error && 'border-destructive'
          )}
          ref={ref}
          {...props}
        />
        {error && <p className="text-sm text-destructive" role="alert">{error}</p>}
      </div>
    );
  }
);
Input.displayName = 'Input';

export { Input };
